import { SupplierItemDto } from '@/api/generated';
import {
  supplierStatusOptionsTranslation,
  SupplierStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { SupplierAddModel } from '@/views/suppliers/list/components/dialog/model/SupplierAdd.model.ts';
import { SuppliersListSearchFormModel } from '@/views/suppliers/list/model/SuppliersListSearchForm.model.ts';

export type SuppliersListTranslation = {
  dialog: {
    add: {
      button: {
        cancel: string;
        createNewContact: string;
        removeContact: string;
        save: string;
        saveAndAdd: string;
      };
      form: Record<keyof Omit<SupplierAddModel, 'contact' | 'createContact'>, string> & {
        button: {
          checkNip: string;
        };
      };
      supplierStatusOptions: SupplierStatusOptionsTranslation;
      title: {
        create: string;
        update: string;
      };
    };
  };
  header: {
    button: {
      add: string;
    };
  };
  table: {
    body: Record<keyof Omit<SupplierItemDto, 'supplierId'>, string> & {
      supplierStatusOptions: SupplierStatusOptionsTranslation;
    };
    details: {
      company: string;
      createdAt: string;
      note: string;
      open: string;
      regon: string;
    };
    head: Record<keyof SuppliersListSearchFormModel, string>;
    quickFilters: {
      active: string;
    };
  };
};

export const suppliersListTranslation: SuppliersListTranslation = {
  dialog: {
    add: {
      button: {
        cancel: 'Anuluj',
        createNewContact: 'Dodaj kontakt',
        removeContact: 'Usuń kontakt',
        save: 'Zapisz',
        saveAndAdd: 'Zapisz i dodaj kolejny',
      },
      form: {
        button: {
          checkNip: 'Pobierz dane',
        },
        community: 'Gmina',
        county: 'Powiat',
        flatNo: 'Numer lokalu',
        houseNo: 'Numer budynku',
        locality: 'Miejscowość',
        name: 'Nazwa',
        nip: 'NIP',
        note: 'Notatka',
        postCode: 'Kod pocztowy',
        province: 'Województwo',
        regon: 'Regon',
        status: 'Status',
        street: 'Ulica',
        type: 'Rodzaj',
      },
      supplierStatusOptions: supplierStatusOptionsTranslation,
      title: {
        create: 'Dodaj dostawcę',
        update: 'Zaktualizuj dostawcę',
      },
    },
  },
  header: {
    button: {
      add: 'Dodaj',
    },
  },
  table: {
    body: {
      address: 'Adres',
      name: 'Nazwa',
      nip: 'NIP',
      status: 'Status',
      supplierStatusOptions: supplierStatusOptionsTranslation,
      type: 'Rodzaj',
    },
    details: {
      company: 'Dane dostawcy',
      createdAt: 'Dodany',
      note: 'Notatka',
      open: 'Otwórz dostawcę',
      regon: 'REGON',
    },
    head: {
      fullTextSearchInput: 'Szukaj',
      status: 'Status',
      types: 'Rodzaj',
    },
    quickFilters: {
      active: 'Tylko aktywni',
    },
  },
};
